export default "__VITE_ASSET__ff5ea409__"